import Chart from 'react-apexcharts'
import { useTranslation } from 'react-i18next'
import { metrics } from './constants'
import { NotFoundIcon } from '../../components/icons'
import Card from '../../components/Card'
import { ExamIcon, EyeIcon } from 'vlab-frontend-components'
import LineChart from '../../components/LineChart'
import FeedbackCardAppDisabled from '../../components/FeedbackCardAppDisabled'

export default function AppDisabled({ insightsData, pagination, setPagination }: any) {
    const { t } = useTranslation()
    const radialSeriesData = [insightsData?.quantity_tree?.organization_quantity || 0, insightsData?.quantity_tree?.room_quantity || 0, insightsData?.quantity_tree?.unit_quantity || 0]
    const lineSeriesData = insightsData?.insight_list
        ? metrics.map((metric) => ({
              name: t(`appEnabled.${metric}`),
              data: insightsData.insight_list.map((item: any) => ({
                  x: new Date(item.insight_date).getTime(),
                  y: item[metric]
              }))
          }))
        : []

    const radialChartOptions = {
        labels: [t('appEnabled.active_brands'), t('appEnabled.units'), t('appEnabled.installed_equipment')],
        plotOptions: {
            radialBar: {
                hollow: {
                    size: '20%'
                },
                dataLabels: {
                    show: false
                }
            }
        },
        colors: ['#0166FF', '#94CEFF', '#8B98A3'],

        tooltip: {
            custom: function ({ series, seriesIndex, dataPointIndex, w }: any) {
                return `<div class="p-4 bg-white rounded border-[1px] border-[#0166FF] ">
                <p class="text-[18px
                ] font-semibold">${series[seriesIndex]}</p>
                <p class="text-[10px] text-[#8B98A3] my-2">${w.config.labels[seriesIndex]}</p>
              </div>`
            },

            enabled: true,
            shared: false,
            x: {
                show: false
            },
            y: {
                title: {
                    formatter: () => ''
                }
            }
        }
    }

    if (!insightsData) return null

    return (
        <div className="py-8 flex leading-3 text-[#51525F] ">
            <div className="flex flex-col lg:flex-row gap-6 w-full">
                <div className="flex flex-col gap-4 w-full">
                    {insightsData?.compare && (
                        <div className="flex gap-6 w-full overflow-x-auto py-2 lg:py-0">
                            <Card
                                text={t('appEnabled.total_exams')}
                                number={insightsData.insight.total_exams || 0}
                                compare={insightsData.compare.total_exams}
                                icon={<ExamIcon width="21px" height="21px" color="white" />}
                                bgColor="bg-[#0166FF]"
                                borderColor="border-[#0166FF]"
                                fullWidth
                            />

                            <Card
                                text={t('appEnabled.exam_view_quantity')}
                                number={insightsData.insight.exam_view_quantity || 0}
                                icon={<EyeIcon width="21px" height="21px" color="white" />}
                                bgColor="bg-[#E20101]"
                                borderColor="border-[#E20101]"
                                compare={insightsData.compare.exam_view_quantity}
                                fullWidth
                            />
                        </div>
                    )}
                    <div className="flex gap-4 flex-col">
                        <div className="donut bg-[#F7F8FC] w-full max-w-[100%] h-[301px] lg:h-[300px]   flex items-center justify-center flex-col rounded ">
                            {lineSeriesData.length > 0 ? (
                                <LineChart data={insightsData.insight_list} appDisabled />
                            ) : (
                                <div className="flex flex-col items-center my-4">
                                    <NotFoundIcon />
                                    <p className="mt-4 text-[12px] font-semibold text-[#51525F]">{t('appEnabled.insufficient_data')}</p>
                                    <p className="mt-2 text-[10px] font-semibold text-[#8B98A3]">{t('appEnabled.clear_filters_try_again')}</p>
                                </div>
                            )}
                        </div>
                        <div className="donut bg-[#F7F8FC] w-full h-[200px] hidden items-center justify-center flex-col rounded md:flex">
                            <p className="font-semibold text-[18px] text-[#51525F] mb-4 mt-4">{t('appEnabled.v_baby_fleury')}</p>
                            <Chart options={radialChartOptions} series={radialSeriesData} type="radialBar" width="160" height="160" />
                        </div>
                        <div className="w-full  flex items-center justify-center flex-col rounded md:hidden">
                            <p className="font-semibold text-[16px] text-[#51525F] mb-4 mt-4">{t('appEnabled.v_baby_fleury')}</p>

                            <div className="mt-4 border-[1px] border-[#ECF2F8] rounded w-full">
                                <div className="p-4 flex items-center justify-center border-b-[1px] border-[#ECF2F8]">
                                    <p>
                                        <span className="font-semibold">{insightsData?.quantity_tree?.organization_quantity || 0}</span> {t('appEnabled.active_brands')}
                                    </p>
                                </div>
                                <div className="p-4 flex items-center justify-center  border-b-[1px] border-[#ECF2F8]">
                                    <p>
                                        <span className="font-semibold">{insightsData?.quantity_tree?.room_quantity || 0}</span> {t('appEnabled.units')}
                                    </p>
                                </div>
                                <div className="p-4 flex items-center justify-center">
                                    <p>
                                        <span className="font-semibold">{insightsData?.quantity_tree?.unit_quantity || 0}</span> {t('appEnabled.installed_equipment')}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col gap-6 items-center  w-full max-w-full lg:max-w-[650px]">
                    <FeedbackCardAppDisabled 
                        feedbacks={insightsData.feedbacks} 
                        containerClassName="w-full max-h-[632px]" 
                        pagination={pagination}
                        setPagination={setPagination}
                    />
                </div>
            </div>
        </div>
    )
}
